module.exports = __webpack_public_path__ + "coin_HKD.svg?0a2a99c1a58342aa1f5cbdcf3165b5e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_HKD.svg
// module id = 1132
// module chunks = 2